var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Order',{ref:"order"}),_c('Dispatch',{ref:"dispatch"}),_c('Remark',{ref:"remark",attrs:{"orderId":_vm.orderId},on:{"load":_vm.getData}}),_c('AuditLog',{ref:"auditLog",attrs:{"orderId":_vm.orderId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }